var OptionalResolver_1;
import * as tslib_1 from "tslib";
import { containerResolver } from '../protocol/resolver';
/**
 * Used to allow functions/classes to specify an optional dependency, which will be resolved
 *      only if already registred with the container.
 */
let OptionalResolver = OptionalResolver_1 = class OptionalResolver {
    /**
     * Creates an instance of the Optional class.
     * @param key The key to optionally resolve for.
     * @param checkParent Indicates whether or not the parent container hierarchy should be checked.
     */
    constructor(key, checkParent = true) {
        this._key = key;
        this._checkParent = checkParent;
    }
    /**
     * Creates an Optional Resolver for the supplied key.
     * @param key The key to optionally resolve for.
     * @param [checkParent=true] Indicates whether or not the parent container hierarchy should be checked.
     * @return Returns an instance of Optional for the key.
     */
    static of(key, checkParent = true) {
        return new OptionalResolver_1(key, checkParent);
    }
    /**
     * Called by the container to provide optional resolution of the key.
     * @param container The container to resolve from.
     * @return Returns the instance if found; otherwise null.
     */
    get(container) {
        if (container.hasHandler(this._key, this._checkParent)) {
            return container.get(this._key);
        }
        return null;
    }
};
OptionalResolver = OptionalResolver_1 = tslib_1.__decorate([
    containerResolver,
    tslib_1.__metadata("design:paramtypes", [Object, Object])
], OptionalResolver);
export { OptionalResolver };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT3B0aW9uYWxSZXNvbHZlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIk9wdGlvbmFsUmVzb2x2ZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFPQSxPQUFPLEVBQUUsaUJBQWlCLEVBQUUsTUFBTSxzQkFBc0IsQ0FBQztBQUd6RDs7O0dBR0c7QUFFSCxJQUFhLGdCQUFnQix3QkFBN0IsTUFBYSxnQkFBZ0I7SUFpQnpCOzs7O09BSUc7SUFDSCxZQUFtQixHQUFXLEVBQUUsV0FBVyxHQUFHLElBQUk7UUFDOUMsSUFBSSxDQUFDLElBQUksR0FBRyxHQUFHLENBQUM7UUFDaEIsSUFBSSxDQUFDLFlBQVksR0FBRyxXQUFXLENBQUM7SUFDcEMsQ0FBQztJQXhCRDs7Ozs7T0FLRztJQUNJLE1BQU0sQ0FBQyxFQUFFLENBQUksR0FBVyxFQUFFLFdBQVcsR0FBRyxJQUFJO1FBQy9DLE9BQU8sSUFBSSxrQkFBZ0IsQ0FBQyxHQUFHLEVBQUUsV0FBVyxDQUFDLENBQUM7SUFDbEQsQ0FBQztJQWtCRDs7OztPQUlHO0lBQ0ksR0FBRyxDQUFDLFNBQW9CO1FBQzNCLElBQUksU0FBUyxDQUFDLFVBQVUsQ0FBQyxJQUFJLENBQUMsSUFBSSxFQUFFLElBQUksQ0FBQyxZQUFZLENBQUMsRUFBRTtZQUNwRCxPQUFPLFNBQVMsQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDO1NBQ25DO1FBRUQsT0FBTyxJQUFJLENBQUM7SUFDaEIsQ0FBQztDQUNKLENBQUE7QUF2Q1ksZ0JBQWdCO0lBRDVCLGlCQUFpQjs7R0FDTCxnQkFBZ0IsQ0F1QzVCO1NBdkNZLGdCQUFnQiJ9